import {Routes} from '@angular/router';
import {Login} from './features/login/login';
import {authGuard, noAuthGuard} from './core/guards/auth-guard'
import {processGuard} from './core/guards/process.guard';
import {RegistroEquipo} from './features/administracion/registro-equipo/registro-equipo';
import {menuScreenLockGuard, screenLockGuard} from './core/guards/screen-lock.guard';
import {ValidaSalirPantallaGuard} from './core/guards/valida-salir-pantalla.guard';

export const routes: Routes = [
    { path: 'login', component: Login, canMatch: [noAuthGuard], },
    { path: 'AdminRegistro', component: RegistroEquipo , canDeactivate: [ValidaSalirPantallaGuard]},
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
      path: '',
      canActivate: [],
      loadComponent: () =>
        import('./core/layout/layout/layout')
          .then(m => m.Layout),
      canActivateChild: [menuScreenLockGuard],
      children: [
        {
          path: 'dashboard',
          loadComponent: () =>
            import('./features/dashboard/dashboard')
              .then(m => m.Dashboard),
          canActivate: [authGuard],
          data: {  }
        },
        {
          path: 'configuracion',
          loadComponent: () =>
            import('./shared/components/configuracion/configuracion')
              .then(m => m.Configuracion),
          canActivate: [authGuard, screenLockGuard],
          data: { proceso: 'SeleccionarPV', auth: true }
        },
        {
          path: 'AltaUsuario',
          loadComponent: () =>
            import('./features/administracion/usuarios/usuarios')
              .then(m => m.Usuarios),
          canActivate: [processGuard, screenLockGuard],
          data: { proceso: 'AltaUsuario', auth: true  }
        },
        {
          path: 'SeleccionarPV',
          loadComponent: () =>
            import('./features/administracion/seleccionar-punto-venta/seleccionar-punto-venta')
              .then(m => m.SeleccionarPuntoVenta),
          canActivate: [authGuard, processGuard, screenLockGuard],
          canDeactivate: [ValidaSalirPantallaGuard],
          data: { proceso: 'SeleccionarPV', auth: true  }
        },
        {
          path: 'debug/errors',
          loadComponent: () => import('./shared/components/errors-logs/errors-logs')
            .then(m => m.ErrorsLogs),
          canActivate: [authGuard, screenLockGuard],
          canDeactivate: [ValidaSalirPantallaGuard],
          data: { proceso: 'SeleccionarPV' } // proceso: 'debugErrors'
        },
        {
          path: 'productos',
          loadChildren: () =>
            import('./features/admin-catalogos/admin-catalogos.routes').then(
              (m) => m.adminCatalogosRoutes
            ),
          canActivate: [screenLockGuard],
          data: { proceso: 'SeleccionarPV', auth: true }
        },
        {
          path: 'promociones',
          loadChildren: () =>
            import('./features/promociones/promociones.routes')
              .then(m => m.PROMOCIONES_ROUTES),
          canActivate: [screenLockGuard],
          data: { proceso: 'SeleccionarPV', auth: true }
        },
        {
          path: 'mantenimiento',
          loadChildren: () =>
            import('./features/administracion/mantenimiento-catalogos/mantenimiento-catalogos.routes')
              .then(m => m.MANTENIMIENTO_CATALOGOS_ROUTES),
          canActivate: [screenLockGuard],
          canDeactivate: [ValidaSalirPantallaGuard],
          data: { proceso: 'MantenimientoCatalogos', auth: true }
        },
        {
          path: 'seguridad',
          loadChildren: () =>
            import('./features/seguridad/seguridad.routes')
              .then(m => m.SEGURIDAD_ROUTES),
          canActivate: [screenLockGuard],
          data: { proceso: 'DashboardSeguridad', auth: true }
        },
        {
          path: 'devolucion',
          loadChildren: () =>
            import('./features/devolucion/devolucion.routes')
              .then(m => m.DEVOLUCION_ROUTES),
          canActivate: [screenLockGuard],
          data: { proceso: 'ConsultaDevoluciones', auth: true }
        },
        {
          path: 'inventario',
          loadChildren: () =>
            import('./features/inventario/inventario.routes')
              .then(m => m.INVENTARIO_ROUTES),
          data: { proceso: 'Inventario', auth: true }
        },
        {
          path: 'notaRemision',
          loadChildren: () =>
            import('./features/notaRemision/notaRemision.routes')
              .then(m => m.NOTAREMISION_ROUTES),
          canActivate: [screenLockGuard],
          data: { proceso: 'SeleccionarPV', auth: true }
        },
        {
          path: 'reportes',
          loadChildren: () =>
            import('./features/reportes/reportes.routes')
              .then(m => m.REPORTES_ROUTES),
          canActivate: [screenLockGuard],
          data: { proceso: 'SeleccionarPV', auth: true }
        },
        {
          path: 'aumentar-folio-colombia',
          loadComponent: () =>
            import('./features/administracion/aumentar-folio-colombia/aumentar-folio-colombia')
              .then(m => m.AumentarFolioColombia),
          canActivate: [authGuard, processGuard, screenLockGuard],
          canDeactivate: [ValidaSalirPantallaGuard],
          data: { proceso: 'SeleccionarPV', auth: true  }
        },
        {
          path: 'sin-acceso',
          loadComponent: () =>
            import(
              './shared/components/sin-acceso/sin-acceso'
              ).then(m => m.SinAcceso)
        },
        { path: '**', loadComponent: () =>
            import('./shared/components/en-construccion/en-construccion').then(m => m.EnConstruccion) }
      ]
    },
    { path: '**', redirectTo: 'dashboard' }
];


